import React from 'react';

import { Badge } from '../Badge';

import { RestProps } from './types';
import { Component } from './styles';

export const Rest = React.memo<RestProps>(({ value }) => {
  return (
    <Component>
      <Badge>{value}%</Badge>
    </Component>
  );
});
